import React, { useEffect } from "react";
import { DeleteIcon, InvoiceIcon } from "asset/icons";
import Dropdown from "component/form/dropDown";
import Input from "component/form/Input";
import SupportDocs from "component/form/supportDocs";
import { ADD_SHIPMENT_DETAILS, shipmentContainerType, shipmentLoadType, shipmentPackageType } from "constants/global";
import PurchaseOrdersSelect from "../../../../component/flex/shipments/components/PurchaseOrderSelect";
import { formatDate } from "component/flex/utils";
import { formatMoney } from "utilities/formatMoney";

const AddItemDetails = ({
    addDocs,
    setAddDocs,
    file,
    setFile,
    firstStepDetails,
    handleFirstFormChange,
    submitFirstForm,
    setOrderDimensionsList,
    orderDimensionsList,
    isFirstStepValid,
    isLoading
}) => {
    const {
        itemName,
        containerType,
        loadType,
        packageType,
        quantity,
        weight,
        length,
        width,
        height,
        description,
    } = firstStepDetails;

    const handleDelete = (id) => {
        setOrderDimensionsList((prev) => prev.filter((item) => item?._id !== id));
    };

      useEffect(() => {
          if (file) {
              const { name, url } = file;
              const value = {name, url, originalName: file?.name}
              handleFirstFormChange({ name: "document", value })
          }
      }, [file])

    return (
        <form className="" onSubmit={(e) => e.preventDefault()}>
            <h3 className="text-main-dark font-[450] text-2xl !mb-6">Add item details</h3>

            <Input
                label="Name your shipment"
                placeholder="TSH-8239"
                value={itemName}
                name="itemName"
                required={true}
                onChange={(value) => {
                    handleFirstFormChange({ name: "itemName", value });
                }}
            />

            <div className="grid grid-cols-2 !gap-3.5">
                <div>
                    <Dropdown
                        value={containerType}
                        name="containerType"
                        options={shipmentContainerType.map((option) => ({
                            label: option,
                            value: option,
                        }))}
                        onChange={(e) => {
                            handleFirstFormChange({ name: "containerType", value: e });
                        }}
                        label="Container Type"
                        labelClassName="!text-[#475467]"
                        placeholder="Choose container type"
                    />
                </div>
                <div>
                    <Dropdown
                        value={loadType}
                        name="loadType"
                        options={shipmentLoadType.map((option) => ({
                            label: option,
                            value: option,
                        }))}
                        onChange={(e) => handleFirstFormChange({ name: "loadType", value: e })}
                        label="Load Type"
                        labelClassName="!text-[#475467]"
                        placeholder="Choose Load type"
                    />
                </div>
            </div>

            <div className="grid grid-cols-4 !gap-3.5">
                <div className="col-span-2">
                    <Dropdown
                        value={packageType}
                        name="packageType"
                        options={shipmentPackageType.map((option) => ({
                            label: option,
                            value: option,
                        }))}
                        onChange={(e) => handleFirstFormChange({ name: "packageType", value: e })}
                        label="Package Type"
                        labelClassName="!text-[#475467]"
                        placeholder="Choose package type"
                    />
                </div>

                <div>
                    <Input
                        label="Total Weight"
                        onChange={(e) => handleFirstFormChange({ name: "weight", value: e })}
                        name="weight"
                        type="number"
                        value={weight}
                        placeholder="E.g. 100"
                        unitWrapperClassName="!mt-0"
                        unit="Kg"
                        className="!mt-0 !shadow-[inset_0_0_0_1000px_#EAECF0]"
                    />
                </div>
                <div>
                    <Input
                        name="quantity"
                        value={quantity}
                        type="number"
                        unitWrapperClassName="!mt-0"
                        className="!mt-0"
                        onChange={(e) => handleFirstFormChange({ name: "quantity", value: e })}
                        label="Total Quantity"
                        placeholder="No of units"
                    />
                </div>
            </div>
            <>
                <p className="font-medium text-sm text-left text-[#475467] !mb-2 !mt-5">
                    Package Dimensions (Optional)
                </p>
                <div className="flex items-center">
                    <Input
                        placeholder="Length"
                        unit="cm"
                        name="length"
                        value={length}
                        type="number"
                        className="!mt-0 !shadow-[inset_0_0_0_1000px_#EAECF0]"
                        unitWrapperClassName="!mt-0"
                        onChange={(e) => handleFirstFormChange({ name: "length", value: e })}
                    />
                    <span className="font-medium text-[#475467] text-sm !mx-2.5">X</span>
                    <Input
                        placeholder="Width"
                        unit="cm"
                        type="number"
                        onChange={(e) => handleFirstFormChange({ name: "width", value: e })}
                        name="width"
                        unitWrapperClassName="!mt-0"
                        className="!mt-0 !shadow-[inset_0_0_0_1000px_#EAECF0]"
                        value={width}
                    />
                    <span className="font-medium text-[#475467] text-sm !mx-2.5">X</span>
                    <Input
                        placeholder="Height"
                        unit="cm"
                        name="height"
                        value={height}
                        type="number"
                        unitWrapperClassName="!mt-0"
                        className="!mt-0 !shadow-[inset_0_0_0_1000px_#EAECF0]"
                        onChange={(e) => handleFirstFormChange({ name: "height", value: e })}
                    />
                </div>
            </>

            <Input
                label="Describe Items"
                type="textarea"
                placeholder="E.g. salmon fishes, bluetooth speakers"
                name="description"
                value={description}
                onChange={(e) => handleFirstFormChange({ name: "description", value: e })}
            />

            <div className="!mb-5">
                <p className="font-medium text-sm text-left text-main-dark !mb-2 !mt-[18px]">
                    Add Purchase Orders (Optional)
                </p>
                {orderDimensionsList?.length ? (
                    orderDimensionsList.map((item, index) => {
                        return (
                            <div key={index} className="flex items-center gap-x-3">
                                <div className="flex justify-between w-full p-3 mb-2 bg-white rounded-lg">
                                    <div className="flex items-center gap-x-2">
                                        <div className="p-2 bg-purple-100 rounded-full">
                                            <InvoiceIcon className="size-4" />
                                        </div>
                                        <div className="flex flex-col">
                                            <p className="">{item?.merchant}</p>
                                            <div className="flex items-center text-xs gap-1 text-[14px] text-[#6B7280]">
                                                <span>{item?.title}</span>
                                                <span>•</span>
                                                <span>{item?.outbound?.businessName}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="flex flex-col">
                                        <p className="text-right">
                                            {item?.totalAmount
                                                ? `₦ ${formatMoney(item?.totalAmount.toFixed(2))}`
                                                : "--"}
                                        </p>
                                        <div className="text-right text-xs text-[#6B7280]">
                                            {formatDate(item?.createdAt)}
                                        </div>
                                    </div>
                                </div>

                                <DeleteIcon
                                    className="pointer"
                                    onClick={() => handleDelete(item?._id)}
                                />
                            </div>
                        );
                    })
                ) : (
                    <PurchaseOrdersSelect setOrderDimensionsList={setOrderDimensionsList} />
                )}
            </div>

            <SupportDocs
                addDocs={addDocs}
                setAddDocs={setAddDocs}
                file={file}
                setFile={setFile}
                showDelete={true}
            />

            <div className="flex !gap-9 justify-end !mt-6">
                <button
                    disabled={isLoading}
                    type="button"
                    className="button text-[#1D2939] font-[450] !py-2 !px-6"
                >
                    Back
                </button>
                <button
                    disabled={!isFirstStepValid?.valid || isLoading}
                    onClick={() => {
                        submitFirstForm(ADD_SHIPMENT_DETAILS);
                    }}
                    className={`!py-2 !px-6 text-white rounded-lg font-[450] ${
                        !isFirstStepValid?.valid ? "bg-[#D9CDFF]" : "!bg-secondary"
                    }`}
                    type="submit"
                >
                    {isLoading ? "Loading..." : "Continue"}
                </button>
            </div>
        </form>
    );
};



export default AddItemDetails;
